(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wall-collection"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('wall-collection')) {
    class WallCollection extends HTMLElement {
      connectedCallback() {
        this.finish = this.dataset.wallDark === 'true' ? 'natural-oak' : 'black-oak';
        this.decorate();
        // Filters, sorting and infinite scroll replace the product grid; decorate new tiles as they appear.
        this.observer = new MutationObserver(() => this.decorate());
        this.observer.observe(document.querySelector('main') || document.body, { childList: true, subtree: true });
      }
      disconnectedCallback() {
        this.observer?.disconnect();
      }
      decorate() {
        document.querySelectorAll('product-card').forEach((card) => {
          const gallery = card.querySelector('.card-gallery');
          if (!gallery || gallery.querySelector('.wall-art')) return;
          const link = card.querySelector('a[href*="/products/"]');
          const handle = link && new URL(link.href, location.origin).pathname.split('/products/')[1]?.split('/')[0];
          if (!handle) return;
          const art = document.createElement('div');
          art.className = 'wall-art';
          const img = new Image();
          img.alt = '';
          img.loading = 'lazy';
          img.decoding = 'async';
          img.src = `${this.dataset.base}${handle}-${this.finish}.webp`;
          // If a product has no cut-out, fall back to its normal photo.
          img.onerror = () => art.remove();
          art.append(img);
          gallery.append(art);
        });
      }
    }
    customElements.define('wall-collection', WallCollection);
  }

  } catch(e) { console.error(e); }
})();
})();
